<template>
  <div v-if="loading" class="text-center text-gray-600 text-default my-4">
    <b-spinner class="align-middle"></b-spinner>
    <strong> Gerando relatório ...</strong>
  </div>
  <div v-else class="p-3">
    <div class="border rounded border-info border-left-4 mb-3" style="background-color: #FAFB7F; border: 1px solid black !important;">
      <div class="p-2 border-bottom d-flex align-items-center">
        <div>
          <h6 class="mb-2 text-gray-600 font-weight-bold">
            Para adicionar um cabeçalho ou rodapé para o relatório, configure no perfil do usuário clicando <a :href="`/users/${sessionUser.id}/edit`" target="_blank">aqui</a>.
          </h6>
        </div>
      </div>
    </div>

    <!-- <div class="alert alert-info mb-3">
      <i class="fa fa-info-circle mr-2"></i>
      Para adicionar um cabeçalho ou rodapé para o relatório, configure no perfil do usuário clicando <a :href="`/users/${sessionUser.id}/edit`" target="_blank">aqui</a>.
    </div> -->

    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <button class="btn btn-primary" @click="exportToPDF">Exportar PDF</button>
        <b-spinner class="align-middle ml-2" v-if="generatingPDF"></b-spinner><strong v-if="generatingPDF"> Gerando PDF...</strong>
      </div>
      <div>
        <button class="btn btn-primary mr-2" @click="openSaveModal">
          <i class="fa fa-save mr-1"></i>
          Salvar campos
        </button>
        <button class="btn btn-primary mr-2" @click="openLoadModal">
          <i class="fa fa-folder-open mr-1"></i>
          Carregar campos
        </button>
      </div>
    </div>

    <div id="genial-report">
      <div class="m-3">
        <ReportSection
          v-for="section in sectionsWithUpdatedNumerals"
          :key="section.id"
          :id="section.id"
          :title="section.title"
          :enabled="section.enabled"
          :noBreak="section.noBreak"
          :isTopicTitle="section.isTopicTitle"
          @toggle="handleSectionToggle"
        >
          <template v-if="section.id === 'CABECALHO'">
            <div class="header">
              <h1 class="title">Parecer Técnico</h1>
              <h2 class="subtitle">Possibilidades de Aposentadoria</h2>
            </div>
          </template>

          <template v-else-if="section.id === 'INFORMACOES_BASICAS'">
            <div class="no-break">
              <p class="bold">{{ customerGender === "Mulher" ? 'Sra.' : 'Sr.' }} {{ customerName }}</p>
              <p class="bold">Data de nascimento: {{ formatDate(customerBirthDate, 'DD/MM/YYYY') }}</p>
              <p><span class="bold">Idade na data do parecer:</span> {{ ageAtCalculationDate }}</p>
              <p><span class="bold">Idade na data da Reforma da Previdência ({{ formattedRegimeDate }}):</span> {{ ageAtRegime }}</p>
              <p>Ingresso no serviço público EM CARGO EFETIVO em <span class="bold">{{ calculationPublicServiceIngressDate }}</span> até presente.</p>
            </div>
          </template>

          <template v-else-if="section.id === 'VINCULOS_CONSIDERADOS_RPPS'">
            <WorkRecordItem
              v-for="record in workRecordsRPPS"
              v-bind:key="record.id"
              v-bind:item="record"
              v-on:addRemuneration="() => {}"
              v-on:edit="() => {}"
              v-on:remove="() => {}"
              v-on:addition="() => {}"
              v-on:deduction="() => {}"
            />
            <textarea class="textbox mb-2" placeholder="Notas adicionais..." v-model="extras.field1rpps" />
          </template>

          <template v-else-if="section.id === 'VINCULOS_CONSIDERADOS_RGPS'">
            <WorkRecordItem
              v-for="record in workRecordsRGPS"
              v-bind:key="record.id"
              v-bind:item="record"
              v-on:addRemuneration="() => {}"
              v-on:edit="() => {}"
              v-on:remove="() => {}"
              v-on:addition="() => {}"
              v-on:deduction="() => {}"
            />
            <textarea class="textbox mb-2" placeholder="Notas adicionais..." v-model="extras.field1rgps" />
          </template>

          <template v-else-if="section.id === 'ANALISE_TEMPO_CONTRIBUICAO_RPPS'">
            <TimeTableSection
              v-for="table in rppsTables"
              :key="table.id"
              :id="table.id"
              :title="table.title"
              :enabled="table.enabled"
              @toggle="(data) => handleTableToggle(data, 'RPPS')"
            >
              <TimeTable
                :title="table.title"
                :currentTimeAtRegime="getTimeValue(currentWorkRecords, regimeDate, table.isCareerTable ? 'isCurrentPosition' : table.fieldName, regimeDate, table.excludeSpecial)"
                :currentTimeAtCalculationDate="getTimeValue(currentWorkRecords, calculationDate, table.isCareerTable ? 'isCurrentPosition' : table.fieldName, regimeDate, table.excludeSpecial)"
                :othersTimeAtRegime="getTimeValue(othersWorkRecords, regimeDate, table.isCareerTable ? 'isCurrentCareer' : table.fieldName, regimeDate, table.excludeSpecial)"
                :othersTimeAtCalculationDate="getTimeValue(othersWorkRecords, calculationDate, table.isCareerTable ? 'isCurrentCareer' : table.fieldName, regimeDate, table.excludeSpecial)"
                :totalTimeAtRegime="getTimeValue(workRecordsRPPS, regimeDate, table.fieldName, regimeDate, table.excludeSpecial)"
                :totalTimeAtCalculationDate="getTimeValue(workRecordsRPPS, calculationDate, table.fieldName, regimeDate, table.excludeSpecial)"
                :isCareerTable="table.isCareerTable"
              />
            </TimeTableSection>

            <textarea class="textbox mb-2" placeholder="Notas adicionais..." v-model="extras.field2rpps" />
          </template>

          <template v-else-if="section.id === 'ANALISE_TEMPO_CONTRIBUICAO_RGPS'">
            <TimeTableSection
              v-for="table in rgpsTables"
              :key="table.id"
              :id="table.id"
              :title="table.title"
              :enabled="table.enabled"
              @toggle="(data) => handleTableToggle(data, 'RGPS')"
            >
              <TimeTable
                :title="table.title"
                :currentTimeAtRegime="getTimeValue(currentWorkRecordsRGPS, regimeDateRGPS, table.isCareerTable ? 'isCurrentPosition' : table.fieldName, regimeDateRGPS, table.excludeSpecial)"
                :currentTimeAtCalculationDate="getTimeValue(currentWorkRecordsRGPS, calculationDate, table.isCareerTable ? 'isCurrentPosition' : table.fieldName, regimeDateRGPS, table.excludeSpecial)"
                :othersTimeAtRegime="getTimeValue(othersWorkRecordsRGPS, regimeDateRGPS, table.isCareerTable ? 'isCurrentCareer' : table.fieldName, regimeDateRGPS, table.excludeSpecial)"
                :othersTimeAtCalculationDate="getTimeValue(othersWorkRecordsRGPS, calculationDate, table.isCareerTable ? 'isCurrentCareer' : table.fieldName, regimeDateRGPS, table.excludeSpecial)"
                :totalTimeAtRegime="getTimeValue(workRecordsRGPS, regimeDateRGPS, table.fieldName, regimeDateRGPS, table.excludeSpecial)"
                :totalTimeAtCalculationDate="getTimeValue(workRecordsRGPS, calculationDate, table.fieldName, regimeDateRGPS, table.excludeSpecial)"
                :isCareerTable="table.isCareerTable"
              />
            </TimeTableSection>

            <textarea class="textbox mb-2" placeholder="Notas adicionais..." v-model="extras.field2rgps" />
          </template>

          <template v-else-if="section.id === 'EMISSAO_CTC'">
            <p class="description">Havendo tempo de contribuição em outros regimes de previdência que não o atual, deverá ser emitida e averbada Certidão de Tempo de Contribuição (CTC).</p>
            <textarea class="textbox mb-2" placeholder="Notas adicionais..." v-model="extras.field3" />
          </template>

          <template v-else-if="section.id === 'POSSIBILIDADES_IMEDIATAS_RPPS'">
            <rule v-for="rule in applicableRules.filter(rule => rule.regimeType === 'RPPS')" :rule="rule" :key="rule.id" />
            <p v-if="!applicableRules.filter(rule => rule.regimeType === 'RPPS').length" class="description">Não há regras aplicáveis.</p>
            <textarea class="textbox mb-2" placeholder="Notas adicionais..." v-model="extras.field4rpps" />
          </template>

          <template v-else-if="section.id === 'POSSIBILIDADES_IMEDIATAS_RGPS'">
            <rule v-for="rule in applicableRules.filter(rule => rule.regimeType === 'RGPS')" :rule="rule" :key="rule.id" />
            <p v-if="!applicableRules.filter(rule => rule.regimeType === 'RGPS').length" class="description">Não há regras aplicáveis.</p>
            <textarea class="textbox mb-2" placeholder="Notas adicionais..." v-model="extras.field4rgps" />
          </template>

          <template v-else-if="section.id === 'POSSIBILIDADES_FUTURAS_RPPS'">
            <rule v-for="rule in futureRules.filter(rule => rule.regimeType === 'RPPS')" :rule="rule" :key="rule.id" isFuture />
            <p v-if="!futureRules.filter(rule => rule.regimeType === 'RPPS').length" class="description">Não há regras futuras.</p>
            <textarea class="textbox mb-2" placeholder="Notas adicionais..." v-model="extras.field5rpps" />
          </template>

          <template v-else-if="section.id === 'POSSIBILIDADES_FUTURAS_RGPS'">
            <rule v-for="rule in futureRules.filter(rule => rule.regimeType === 'RGPS')" :rule="rule" :key="rule.id" isFuture />
            <p v-if="!futureRules.filter(rule => rule.regimeType === 'RGPS').length" class="description">Não há regras futuras.</p>
            <textarea class="textbox mb-2" placeholder="Notas adicionais..." v-model="extras.field5rgps" />
          </template>

          <template v-else-if="section.id === 'ABONO_PERMANENCIA'">
            <p class="description">O abono de permanência é o creditamento do total ou parcial da contribuição previdenciária ao servidor público que atinge as regras para aposentadoria, mas permanece em atividade.</p>
            <textarea class="textbox mb-2" placeholder="Notas adicionais..." v-model="extras.field6" />
          </template>

          <template v-else-if="section.id === 'LICENCAS_PREMIO'">
            <p class="description">O pedido de conversão da licença prêmio não usufruída em pecúnia deve ser feito em até 5 anos após a concessão de aposentadoria.</p>
            <textarea class="textbox mb-2" placeholder="Notas adicionais..." v-model="extras.field7" />
          </template>

          <template v-else-if="section.id === 'ISENCAO_IMPOSTO'">
            <p class="description">Aos portadores de doenças graves, é garantido o direito à isenção de imposto de renda e contribuição previdenciárias retidos diretamente na fonte dos benefícios de aposentadoria e pensão por morte.</p>
            <p class="description">O entendimento atual é de que uma vez que o indivíduo comprove que já esteve acometido da doença grave, nasceria para ele o direito à referida isenção, não sendo necessário comprovar que os sintomas da doença são contemporâneos.</p>
            <p class="description">As doenças que garantem a isenção são as seguintes:</p>

            <ul class="description-list">
              <li>AIDS (Síndrome da Imunodeficiência Adquirida)</li>
              <li>Alienação Mental</li>
              <li>Cardiopatia Grave</li>
              <li>Cegueira (inclusive monocular)</li>
              <li>Contaminação por Radiação</li>
              <li>Doença de Paget em estados avançados (Osteíte Deformante)</li>
              <li>Doença de Parkinson</li>
              <li>Esclerose Múltipla</li>
              <li>Espondiloartrose Anquilosante</li>
              <li>Fibrose Cística (Mucoviscidose)</li>
              <li>Hanseníase</li>
              <li>Nefropatia Grave</li>
              <li>Hepatopatia Grave</li>
              <li>Neoplasia Maligna</li>
              <li>Paralisia Irreversível e Incapacitante</li>
              <li>Tuberculose Ativa</li>
            </ul>
            <textarea class="textbox mb-2" placeholder="Notas adicionais..." v-model="extras.field8" />
          </template>

          <template v-else-if="section.id === 'OBSERVACOES_FINAIS'">
            <p class="description">Lembre-se que as projeções são feitas sempre levando em consideração as regras vigentes na data do parecer.</p>
            <p class="description">Alterações legislativas e jurisprudenciais podem alterar o resultado de nossas simulações.</p>
            <textarea class="textbox mb-2" placeholder="Observações finais..." v-model="extras.observation" />
          </template>

          <template v-else-if="section.id === 'PLANO_ACAO'">
            <textarea class="textbox mb-2" placeholder="Plano de ação..." v-model="extras.action" />
          </template>

          <template v-else-if="section.id === 'RODAPE'">
            <p class="description">Agradecemos a confiança!</p>
            <p class="footer"><input type="text" v-model="lawyerName" placeholder="Nome do Advogado" /></p>
            <p class="footer">OAB/<input type="text" v-model="oabValue" placeholder="XX n. XXXXX" /></p>
          </template>
        </ReportSection>
      </div>

      <!-- <div class="page-footer text-center">
        <p>RODAPÉ</p>
      </div> -->
    </div>

    <SaveLoadFieldsModal 
      v-if="showSaveLoadModal"
      :action="modalAction"
      @hidden="closeSaveLoadModal"
      @save="handleSaveFields"
      @load="handleLoadFields"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import WorkRecordItem from './work-records/components/WorkRecordItem.vue';
import Rule from '@/components/Rule.vue';
import { getApplicableRules, getFutureRules } from '@/services/customers';
import { getTime } from '../../utils/common';
import axios from 'axios';
import TimeTable from '@/components/TimeTable.vue';
import ReportSection from '@/components/ReportSection.vue';
import TimeTableSection from '@/components/TimeTableSection.vue';
import SaveLoadFieldsModal from '@/components/SaveLoadFieldsModal.vue';

export default {
  name: 'GenialReport',
  components: { Rule, WorkRecordItem, TimeTable, ReportSection, TimeTableSection, SaveLoadFieldsModal },

  props: {
    workRecords: {
      type: Array,
      default: () => []
    },
    customer: {
      type: Object,
      default: () => {}
    },
    calculation: {
      type: Object,
      default: () => {}
    },
    regimeDate: {
      type: String,
      default: ''
    },
    regimeType: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      loading: false,
      totalLoading: 1,
      currentLoading: 0,
      applicableRules: [],
      futureRules: [],
      extras: {
        field1rpps: '',
        field2rpps: '',
        field1rgps: '',
        field2rgps: '',
        field3: '',
        field4rpps: '',
        field4rgps: '',
        field5rpps: '',
        field5rgps: '',
        field6: '',
        field7: '',
        field8: '',
        observation: '',
        action: ''
      },
      lawyerName: '',
      oabValue: '',
      generatingPDF: false,
      showSaveLoadModal: false,
      modalAction: 'save',
      sections: [
        {
          id: 'CABECALHO',
          title: 'Cabeçalho',
          enabled: true,
          noBreak: false,
          isTopicTitle: false
        },
        {
          id: 'INFORMACOES_BASICAS',
          title: 'Informações Básicas',
          enabled: true,
          noBreak: true,
          isTopicTitle: false
        },
        {
          id: 'VINCULOS_CONSIDERADOS_RPPS',
          title: 'I. Vínculos considerados (RPPS)',
          enabled: true,
          noBreak: false,
          isTopicTitle: true
        },
        {
          id: 'VINCULOS_CONSIDERADOS_RGPS',
          title: 'I. Vínculos considerados (RGPS)',
          enabled: true,
          noBreak: false,
          isTopicTitle: true
        },
        {
          id: 'ANALISE_TEMPO_CONTRIBUICAO_RPPS',
          title: 'II. Análise do Tempo de Contribuição (RPPS)',
          enabled: true,
          noBreak: false,
          isTopicTitle: true
        },
        {
          id: 'ANALISE_TEMPO_CONTRIBUICAO_RGPS',
          title: 'II. Análise do Tempo de Contribuição (RGPS)',
          enabled: true,
          noBreak: false,
          isTopicTitle: true
        },
        {
          id: 'EMISSAO_CTC',
          title: 'III. Emissão de CTC de outros regimes',
          enabled: true,
          noBreak: true,
          isTopicTitle: true
        },
        {
          id: 'POSSIBILIDADES_IMEDIATAS_RPPS',
          title: 'IV. Possibilidades imediatas de aposentadoria (RPPS)',
          enabled: true,
          noBreak: false,
          isTopicTitle: true
        },
        {
          id: 'POSSIBILIDADES_IMEDIATAS_RGPS',
          title: 'IV. Possibilidades imediatas de aposentadoria (RGPS)',
          enabled: true,
          noBreak: false,
          isTopicTitle: true
        },
        {
          id: 'POSSIBILIDADES_FUTURAS_RPPS',
          title: 'V. Possibilidades futuras de aposentadoria (RPPS)',
          enabled: true,
          noBreak: false,
          isTopicTitle: true
        },
        {
          id: 'POSSIBILIDADES_FUTURAS_RGPS',
          title: 'V. Possibilidades futuras de aposentadoria (RGPS)',
          enabled: true,
          noBreak: false,
          isTopicTitle: true
        },
        {
          id: 'ABONO_PERMANENCIA',
          title: 'VI. Abono de permanência',
          enabled: true,
          noBreak: true,
          isTopicTitle: true
        },
        {
          id: 'LICENCAS_PREMIO',
          title: 'VII. Licenças prêmio não usufruídas',
          enabled: true,
          noBreak: true,
          isTopicTitle: true
        },
        {
          id: 'ISENCAO_IMPOSTO',
          title: 'VIII. Isenção de imposto de renda',
          enabled: true,
          noBreak: true,
          isTopicTitle: true
        },
        {
          id: 'OBSERVACOES_FINAIS',
          title: 'Observações finais',
          enabled: true,
          noBreak: true,
          isTopicTitle: true
        },
        {
          id: 'PLANO_ACAO',
          title: 'Plano de ação',
          enabled: true,
          noBreak: true,
          isTopicTitle: true
        },
        {
          id: 'RODAPE',
          title: 'Rodapé',
          enabled: true,
          noBreak: true,
          isTopicTitle: false
        }
      ],
      rppsTables: [
        {
          id: 'TEMPO_CONTRIBUICAO_COMUM',
          title: 'Tempo de Contribuição Comum',
          enabled: true,
          fieldName: null,
          excludeSpecial: true
        },
        {
          id: 'TEMPO_ESPECIAL',
          title: 'Tempo Especial',
          enabled: true,
          fieldName: 'isSpecialTime'
        },
        {
          id: 'TEMPO_CONTRIBUICAO_CONVERSAO',
          title: 'Tempo de Contribuição com Conversão',
          enabled: false,
          fieldName: null
        },
        {
          id: 'TEMPO_MAGISTERIO',
          title: 'Tempo de Magistério',
          enabled: true,
          fieldName: 'isTeaching'
        },
        {
          id: 'TEMPO_POLICIA',
          title: 'Tempo de Polícia',
          enabled: true,
          fieldName: 'isPoliceTime'
        },
        {
          id: 'TEMPO_SERVICO_PUBLICO',
          title: 'Tempo de Serviço Público',
          enabled: true,
          fieldName: 'isPublicService'
        },
        {
          id: 'TEMPO_CARGO_CARREIRA',
          title: 'Tempo no Cargo e Carreira',
          enabled: true,
          fieldName: null,
          isCareerTable: true
        }
      ],
      rgpsTables: [
        {
          id: 'TEMPO_CONTRIBUICAO_COMUM',
          title: 'Tempo de Contribuição Comum',
          enabled: true,
          fieldName: null,
          excludeSpecial: true
        },
        {
          id: 'TEMPO_ESPECIAL',
          title: 'Tempo Especial',
          enabled: true,
          fieldName: 'isSpecialTime'
        },
        {
          id: 'TEMPO_CONTRIBUICAO_CONVERSAO',
          title: 'Tempo de Contribuição com Conversão',
          enabled: false,
          fieldName: null
        },
        {
          id: 'TEMPO_MAGISTERIO',
          title: 'Tempo de Magistério',
          enabled: true,
          fieldName: 'isTeaching'
        },
        {
          id: 'TEMPO_POLICIA',
          title: 'Tempo de Polícia',
          enabled: true,
          fieldName: 'isPoliceTime'
        },
        {
          id: 'TEMPO_SERVICO_PUBLICO',
          title: 'Tempo de Serviço Público',
          enabled: true,
          fieldName: 'isPublicService'
        },
        {
          id: 'TEMPO_CARGO_CARREIRA',
          title: 'Tempo no Cargo e Carreira',
          enabled: true,
          fieldName: null,
          isCareerTable: true
        }
      ]
    }
  },

  watch: {
    sections: {
      handler() {
        this.$forceUpdate();
      },
      deep: true
    },
    regimeType: {
      handler() {
        this.updateSectionsVisibility();
      },
      immediate: true
    },
    workRecords: {
      handler() {
        this.updateTablesVisibility();
      },
      immediate: true
    }
  },

  mounted() {
    this.getRules();
  },

  computed: {
    ...mapGetters(['sessionUser']),

    workRecordsRPPS() {
      return this.workRecords.filter(record => record.regimeType === 'RPPS') || [];
    },

    workRecordsRGPS() {
      return this.workRecords.filter(record => record.regimeType === 'RGPS') || [];
    },

    regimeDateRGPS() {
      return moment('2019-11-13');
    },

    hasSpecialTimeRPPS() {
      return this.workRecordsRPPS.some(record => record.isSpecialTime);
    },

    hasSpecialTimeRGPS() {
      return this.workRecordsRGPS.some(record => record.isSpecialTime);
    },

    sectionsWithUpdatedNumerals() {
      const sectionsWithNumerals = [
        'VINCULOS_CONSIDERADOS_RPPS',
        'VINCULOS_CONSIDERADOS_RGPS', 
        'ANALISE_TEMPO_CONTRIBUICAO_RPPS',
        'ANALISE_TEMPO_CONTRIBUICAO_RGPS',
        'EMISSAO_CTC',
        'POSSIBILIDADES_IMEDIATAS_RPPS',
        'POSSIBILIDADES_IMEDIATAS_RGPS',
        'POSSIBILIDADES_FUTURAS_RPPS',
        'POSSIBILIDADES_FUTURAS_RGPS',
        'ABONO_PERMANENCIA',
        'LICENCAS_PREMIO',
        'ISENCAO_IMPOSTO'
      ];

      const enabledSectionsWithNumerals = this.sections
        .filter(section => sectionsWithNumerals.includes(section.id) && section.enabled);

      const romanNumerals = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];

      return this.sections.map(section => {
        if (!sectionsWithNumerals.includes(section.id)) {
          return section;
        }

        const enabledIndex = enabledSectionsWithNumerals.findIndex(s => s.id === section.id);
        if (enabledIndex === -1) {
          return {
            ...section,
            title: section.title.replace(/^[IVX]+\.\s*/, '')
          };
        }

        const newNumeral = romanNumerals[enabledIndex];
        const titleWithoutNumeral = section.title.replace(/^[IVX]+\.\s*/, '');
        
        return {
          ...section,
          title: `${newNumeral}. ${titleWithoutNumeral}`
        };
      });
    },

    customerGender() {
      return this.customer ? this.customer.gender : '';
    },

    customerName() {
      return this.customer ? this.customer.name : ''; 
    },

    customerBirthDate() {
      return this.customer ? this.customer.birthDate : '';
    },

    calculationPublicServiceIngressDate() {
      return this.calculation ? this.calculation.publicServiceIngressDate : '';
    },

    calculationDate() {
      return this.calculation ? moment(this.calculation.calculationDate, 'DD-MM-YYYY') : moment();
    },

    formattedRegimeDate() {
      return this.calculation?.regime === "Sem Reforma" ? "ENTE FEDERATIVO SEM REFORMA" : moment(this.regimeDate).format('DD/MM/YYYY');
    },

    ageAtCalculationDate() {
      let calcDate = moment(this.calculationDate);

      const yearAtCalculationDate = moment(calcDate).diff(moment(this.customerBirthDate), 'years');
      calcDate.subtract(yearAtCalculationDate, 'years');
      const monthAtCalculationDate = moment(calcDate).diff(moment(this.customerBirthDate), 'months');
      calcDate.subtract(monthAtCalculationDate, 'months');
      const dayAtCalculationDate = moment(calcDate).diff(moment(this.customerBirthDate), 'days');
      
      return this.formatAgeAtCalculationDate({ years: yearAtCalculationDate, months: monthAtCalculationDate, days: dayAtCalculationDate });
    },

    ageAtRegime() {
      let calcDate = moment(this.regimeDate);

      const yearAtRegimeDate = moment(calcDate).diff(moment(this.customerBirthDate), 'years');
      calcDate.subtract(yearAtRegimeDate, 'years');
      const monthAtRegimeDate = moment(calcDate).diff(moment(this.customerBirthDate), 'months');
      calcDate.subtract(monthAtRegimeDate, 'months');
      const dayAtRegimeDate = moment(calcDate).diff(moment(this.customerBirthDate), 'days');
      
      return this.formatAgeAtRegimeDate({ years: yearAtRegimeDate, months: monthAtRegimeDate, days: dayAtRegimeDate });
    },

    currentWorkRecords() {
      return this.workRecordsRPPS.filter(record => record.isCurrentPosition || record.isCurrentCareer);
    },
    
    othersWorkRecords() {
      return this.workRecordsRPPS.filter(record => !(record.isCurrentPosition || record.isCurrentCareer));
    },

    currentWorkRecordsRGPS() {
      return this.workRecordsRGPS.filter(record => record.isCurrentPosition || record.isCurrentCareer);
    },
    
    othersWorkRecordsRGPS() {
      return this.workRecordsRGPS.filter(record => !(record.isCurrentPosition || record.isCurrentCareer));
    }
  },

  methods: {
    ...mapActions('workRecords', ['loadWorkRecords']),

    getTimeValue(workRecords, limitDate, field = null, regimeDate = null, excludeSpecial = false) {
      if (!workRecords || workRecords.length === 0) {
        return this.formatContributionText({ years: 0, months: 0, days: 0 });
      }

      const time = getTime(workRecords, limitDate, field, this.customerGender, regimeDate || this.regimeDate, excludeSpecial);
      
      return this.formatContributionText(time);
    },

    getStorageKey() {
      return 'genial_report';
    },

    saveExtrasToLocalStorage() {
      const storageKey = this.getStorageKey();
      const dataToSave = {
        calculation_id: this.$route.params.calculationId,
        extras: this.extras,
        lawyerName: this.lawyerName,
        oabValue: this.oabValue,
        sections: this.sections,
        rppsTables: this.rppsTables,
        rgpsTables: this.rgpsTables
      };
      
      try {
        localStorage.setItem(storageKey, JSON.stringify(dataToSave));
      } catch (error) {
        console.error('Error saving to localStorage:', error);
      }
    },

    loadExtrasFromLocalStorage() {
      const storageKey = this.getStorageKey();
      
      try {
        const savedData = localStorage.getItem(storageKey);
        if (savedData) {
          const parsedData = JSON.parse(savedData);
          
          if (parsedData.extras) {
            this.extras = { ...this.extras, ...parsedData.extras };
          }
          
          if (parsedData.lawyerName) {
            this.lawyerName = parsedData.lawyerName;
          }
          
          if (parsedData.oabValue) {
            this.oabValue = parsedData.oabValue;
          }
          
          if (parsedData.sections) {
            this.sections = parsedData.sections;
          }
          
          if (parsedData.rppsTables) {
            this.rppsTables = parsedData.rppsTables;
          }
          
          if (parsedData.rgpsTables) {
            this.rgpsTables = parsedData.rgpsTables;
          }
        }
      } catch (error) {
        console.error('Error loading from localStorage:', error);
      }
    },

    async getWorkRecords() {
      await this.loadWorkRecords(this.$route.params.calculationId);

      this.finishLoading();
    },

    async getRules() {
      this.loading = true;

      const rppsResponse = await axios.get(`/calculations/${this.$route.params.calculationId}/rules`, {
        params: { regimeType: 'RPPS' }
      });

      const rgpsResponse = await axios.get(`/calculations/${this.$route.params.calculationId}/rules`, {
        params: { regimeType: 'RGPS' }
      });

      this.applicableRules = [...rppsResponse.data.applicableRules, ...rgpsResponse.data.applicableRules];
      this.futureRules = [...rppsResponse.data.futureRules, ...rgpsResponse.data.futureRules];

      // this.customer = rppsResponse.data.customer;
      // this.calculation = rppsResponse.data.calculation;
      // this.regimeDate = rppsResponse.data.regimeDate;

      this.finishLoading();
    },

    async getFutureRules() {
      this.loading = true;

      const { rules, customer, calculation, regimeDate } = await getFutureRules(this.$route.params.calculationId);
      this.futureRules = rules;
      // this.customer = customer;
      // this.calculation = calculation;
      // this.regimeDate = regimeDate;

      this.finishLoading();
    },

    formatDate(date, format) {
      return moment(date).format(format);
    },

    finishLoading() {
      this.currentLoading++;

      if (this.currentLoading >= this.totalLoading) {
        this.loading = false;
      }
    },

    formatAgeAtRegimeDate({ days, months, years }) {
      if (!years && !months && !days) return '---';

      let text = '';

      if (years > 0) {
        text += `${years} ano`;

        if (years > 1) {
          text += 's';
        }
      }

      if (months > 0) {
        if (years > 0) {
          if (days > 0) {
            text += ', ';
          } else {
            text += ' e ';
          }
        }

        if (months > 1) {
          text += `${months} meses`;
        } else {
          text += `${months} mês`;
        }
      }

      if (days > 0) {
        if (years > 0 || months > 0) {
          text += ' e ';
        }

        text += `${days} dia`;

        if (days > 1) {
          text += 's';
        }
      }

      text += '.';

      return text;
    },

    formatAgeAtCalculationDate({ days, months, years }) {
      if (!years && !months && !days) return '---';

      let text = '';

      if (years > 0) {
        text += `${years} ano`;

        if (years > 1) {
          text += 's';
        }
      }

      if (months > 0) {
        if (years > 0) {
          if (days > 0) {
            text += ', ';
          } else {
            text += ' e ';
          }
        }

        if (months > 1) {
          text += `${months} meses`;
        } else {
          text += `${months} mês`;
        }
      }

      if (days > 0) {
        if (years > 0 || months > 0) {
          text += ' e ';
        }

        text += `${days} dia`;

        if (days > 1) {
          text += 's';
        }
      }

      text += '.';

      return text;
    },

    formatContributionText({ days, months, years }) {
      if (!years && !months && !days) return '---';

      let text = '';

      if (years > 0) {
        text += `${years} ano`;

        if (years > 1) {
          text += 's';
        }
      }

      if (months > 0) {
        if (years > 0) {
          if (days > 0) {
            text += ', ';
          } else {
            text += ' e ';
          }
        }

        if (months > 1) {
          text += `${months} meses`;
        } else {
          text += `${months} mês`;
        }
      }

      if (days > 0) {
        if (years > 0 || months > 0) {
          text += ' e ';
        }

        text += `${days} dia`;

        if (days > 1) {
          text += 's';
        }
      }

      text += '.';

      return text;
    },

    async printReport() {
      const div = document.getElementById('genial-report');

      let style = '';

      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        style += node.outerHTML;
      }

      const win = window.open();

      win.document.write(`<style>${style}</style>`);
      win.document.write(div.innerHTML);

      win.document.close();
      win.focus();
      win.print();
      win.close();
    },

    async exportToPDF() {
      this.generatingPDF = true;

      try {
        const params = {
          calculationId: this.$route.params.calculationId,
          field1rpps: this.extras.field1rpps,
          field1rgps: this.extras.field1rgps,
          field2rpps: this.extras.field2rpps,
          field2rgps: this.extras.field2rgps,
          field3: this.extras.field3,
          field4rpps: this.extras.field4rpps,
          field4rgps: this.extras.field4rgps,
          field5rpps: this.extras.field5rpps,
          field5rgps: this.extras.field5rgps,
          field6: this.extras.field6,
          field7: this.extras.field7,
          field8: this.extras.field8,
          observation: this.extras.observation,
          action: this.extras.action,
          lawyerName: this.lawyerName, 
          oabValue: this.oabValue,
          sections: this.sections.filter(section => section.enabled).map(section => (section.id)),
          rppsTables: this.rppsTables.filter(table => table.enabled).map(table => (table.id)),
          rgpsTables: this.rgpsTables.filter(table => table.enabled).map(table => (table.id))
        };

        const response = await axios.post('/reports/genial-report', { ...params });

        const linkSource = `data:application/pdf;base64,${response.data}`;
        const downloadLink = document.createElement("a");
        const fileName = `Relatório Genial.pdf`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } catch (err) {
        console.log("err", err);
      }

      this.generatingPDF = false;
    },

    handleSectionToggle({ id, enabled }) {
      const section = this.sections.find(s => s.id === id);
      if (section) {
        section.enabled = enabled;
      }
    },

    handleTableToggle({ id, enabled }, tableType) {
      const tables = tableType === 'RPPS' ? this.rppsTables : this.rgpsTables;
      const table = tables.find(t => t.id === id);
      if (table) {
        table.enabled = enabled;
      }
    },

    getSectionEnabled(id) {
      const section = this.sections.find(s => s.id === id);
      return section ? section.enabled : false;
    },

    updateSectionsVisibility() {
      const DEFAULT_RGPS_SECTIONS = [
        'CABECALHO',
        'INFORMACOES_BASICAS',
        'VINCULOS_CONSIDERADOS_RGPS',
        'ANALISE_TEMPO_CONTRIBUICAO_RGPS',
        'EMISSAO_CTC',
        'POSSIBILIDADES_IMEDIATAS_RGPS',
        'POSSIBILIDADES_FUTURAS_RGPS',
        'ABONO_PERMANENCIA',
        'LICENCAS_PREMIO',
        'ISENCAO_IMPOSTO',
        'OBSERVACOES_FINAIS',
        'PLANO_ACAO',
        'RODAPE'
      ];

      const DEFAULT_RPPS_SECTIONS = [
        'CABECALHO',
        'INFORMACOES_BASICAS',
        'VINCULOS_CONSIDERADOS_RPPS',
        'ANALISE_TEMPO_CONTRIBUICAO_RPPS',
        'EMISSAO_CTC',  
        'POSSIBILIDADES_IMEDIATAS_RPPS',
        'POSSIBILIDADES_FUTURAS_RPPS',
        'ABONO_PERMANENCIA',
        'LICENCAS_PREMIO',  
        'ISENCAO_IMPOSTO',
        'OBSERVACOES_FINAIS',
        'PLANO_ACAO',
        'RODAPE'
      ];

      const DEFAULT_SECTIONS = this.regimeType === 'RPPS' ? DEFAULT_RPPS_SECTIONS : DEFAULT_RGPS_SECTIONS;

      this.sections.forEach(section => {
        if (DEFAULT_SECTIONS.includes(section.id)) {
          section.enabled = true;
        } else {
          section.enabled = false;
        }
      });
    },

    updateTablesVisibility() {
      this.rppsTables.forEach(table => {
        if (table.id === 'TEMPO_CONTRIBUICAO_CONVERSAO') {
          table.enabled = this.hasSpecialTimeRPPS;
        }
      });

      this.rgpsTables.forEach(table => {
        if (table.id === 'TEMPO_CONTRIBUICAO_CONVERSAO') {
          table.enabled = this.hasSpecialTimeRGPS;
        }
      });
    },

    openSaveModal() {
      this.modalAction = 'save';
      this.showSaveLoadModal = true;
    },

    openLoadModal() {
      const hasSavedData = this.checkForSavedData();
      if (hasSavedData) {
        this.modalAction = 'load';
      } else {
        this.modalAction = 'no-data';
      }
      this.showSaveLoadModal = true;
    },

    closeSaveLoadModal() {
      this.showSaveLoadModal = false;
    },

    checkForSavedData() {
      const storageKey = this.getStorageKey();
      try {
        const savedData = localStorage.getItem(storageKey);
        if (savedData) {
          const parsedData = JSON.parse(savedData);
          return parsedData;
        }
      } catch (error) {
        console.error('Error checking saved data:', error);
      }
      return false;
    },

    handleSaveFields() {
      this.saveExtrasToLocalStorage();
      this.$toast.open({
        message: 'Campos salvos com sucesso!',
        type: 'success',
        position: 'top-right'
      });
    },

    handleLoadFields() {
      this.loadExtrasFromLocalStorage();
      this.$toast.open({
        message: 'Campos carregados com sucesso!',
        type: 'success',
        position: 'top-right'
      });
    }
  }
}
</script>

<style scoped>
  @media print 
  {
    @page {
      size: A4;
      margin: 0 0;
    }
    html, body {
      width: 210mm;
      height: 282mm;
      font-size: 11px;
      background: #FFF;
      overflow: visible;
    }
    body {
      padding: 25mm 0;
      print-color-adjust: exact; 
    }
    .page-header {
      position: fixed;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .page-footer {
      position: fixed;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .no-break { break-inside: avoid; } 

  .title {
    border-bottom: 1px solid #4bacc6;
    color: #4bacc6;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 0;
    text-align: center;
    text-transform: uppercase;
  }

  .subtitle {
    color: #4bacc6;
    font-size: 16px;
    font-style: italic;
    text-align: center;
  }

  .bold {
    font-weight: bold;
  }

  .topic-title {
    background-color: #dbe5f1;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    padding: 32px;
    margin-bottom: 16px;
  }

  .table-title {
    background-color: #dbe5f1;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 0;
  }

  .flex {
    display: flex;
    flex-wrap: wrap;
  }

  .description {
    color: black;
    text-indent: 32px;
  }

  .description-list {
    padding-inline-start: 64px;
  }

  .footer {
    text-align: center;
    font-weight: bold;
    margin: 0;
  }

  .textbox {
    width: 100%;
    height: 128px;
  }
</style>
